import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faXmark,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
} from '@fortawesome/pro-regular-svg-icons'
import { useLabraChatDispatch } from '../../../modules/labraChat/context'
import { closeLabraChatEmailPreview } from '../../../modules/labraChat/actions'
import { LabraChatEmailPreview } from '../../../modules/labraChat/reducer'
import { useStyles } from './ChatEmailPreviewModal.styles'

type Props = {
  preview: LabraChatEmailPreview
  isExpanded: boolean
  onToggleExpanded: () => void
  className?: string
}

/**
 * Figma 641:4730 / 714:3485 — right split-pane Email HTML preview
 * (chat left, branded HTML iframe right). Matches ChatDocumentPreview chrome.
 */
export const ChatEmailPreviewModal: React.FC<Props> = ({
  preview,
  isExpanded,
  onToggleExpanded,
  className,
}) => {
  const { classes, cx } = useStyles()
  const dispatch = useLabraChatDispatch()

  const title = preview.subject?.trim() || 'Email preview'

  return (
    <div
      className={cx(classes.root, className)}
      data-testid="chat-email-preview-modal"
      role="complementary"
      aria-label="Email preview"
    >
      <div className={classes.header}>
        <span className={classes.title} title={title}>
          {title}
        </span>
        <div className={classes.actions}>
          <button
            type="button"
            className={classes.iconButton}
            onClick={onToggleExpanded}
            title={isExpanded ? 'Show conversation' : 'Hide conversation'}
            aria-label={isExpanded ? 'Show conversation' : 'Hide conversation'}
          >
            <FontAwesomeIcon
              icon={
                isExpanded
                  ? faArrowDownLeftAndArrowUpRightToCenter
                  : faArrowUpRightAndArrowDownLeftFromCenter
              }
            />
          </button>
          <button
            type="button"
            className={classes.iconButton}
            onClick={() => dispatch(closeLabraChatEmailPreview())}
            title="Close preview"
            aria-label="Close preview"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>
      <iframe
        className={classes.frame}
        title={title}
        srcDoc={preview.html}
        sandbox="allow-same-origin"
        data-testid="chat-email-preview-frame"
      />
    </div>
  )
}
